import { render, staticRenderFns } from "./mageCenter.vue?vue&type=template&id=30f8d6de&scoped=true&"
import script from "./mageCenter.vue?vue&type=script&lang=js&"
export * from "./mageCenter.vue?vue&type=script&lang=js&"
import style0 from "./mageCenter.vue?vue&type=style&index=0&id=30f8d6de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f8d6de",
  null
  
)

export default component.exports